import Colors from './color';
import { IMenuVersion } from './menu';
import { TOTAL_PLACEHOLDER, ITEM_NAME_PLACEHOLDER } from '../constants';

export const CLOUDFRONT_BASE_URL = 'https://d3hj7yqiplb18y.cloudfront.net/';

export const LANGUAGE_SWITCH_INTENT = '#language_switch';

export const LANGUAGE_SWITCH_INTENT_CARD = {
  color: Colors.white,
  cardSize: 12,
  intent: LANGUAGE_SWITCH_INTENT,
};

export const TOTAL_TTS = "That'll be " + TOTAL_PLACEHOLDER + '.';

// Item-price click: phrase the single item's price the way the AI does,
// e.g. "The Original Cheeseburger is 1 dollar. Would you like to add one?"
export const ITEM_PRICE_TTS =
  'The ' +
  ITEM_NAME_PLACEHOLDER +
  ' is ' +
  TOTAL_PLACEHOLDER +
  '. Would you like to add one?';

export const HYPOTHESE_MINI_CONFIDENCE = 0;

export enum END_SESSION_REASON {
  CANCEL_ORDER = 'cancel_order',
  FINISH_ORDER = 'finish_order',
}

export const POS_BOOLEAN_PROPERTIES_LIST = [
  'is_combo',
  'is_modifier',
  'is_coupon',
  'is_main_item',
];

export const PROD_ACCESS_DETAILS = {
  'prod-access-key': 'd3b9116eaaa8022368e21e2a1c96a49a',
};
export const DUMMY_MOD_SYMBOL = '.';

export const OH = 'Oh';
export const LOWER_CASE_O = 'o';
export const VOICE_PROPERTIES = 'voice_properties';
export const SOURCE = 'HITL';

export const RESTAURANT_DIAGNOSTIC_USERNAME = 'restaurant-diagnostic';
export const RESTAURANT_DIAGNOSTIC_PASSWORD = 'diagnostic@presto';

export const TIME_PERIOD_CHECK_INTERVAL = 30 * 1000;

// Poll cadence for the deployed build-number check. 5 min is plenty given our
// ~daily release cadence; the Slack notice covers the rest.
export const BUILD_NUMBER_CHECK_INTERVAL = 5 * 60 * 1000; // 300000 ms

export const defaultMenuVersion = { commitId: 'latest' } as IMenuVersion;
export const GROUP_ID_MAPPING_DEFAULT_RESTAURANT = 'cke_corp_reduced';

// sample total message '4 dollars 2 cents'
export const BRANDS_REQUIRE_LONG_MESSAGE_WITH_TOTAL = ['fazolis'];

export const TTS_ON_COMMAND = '//ttson';
export const TTS_OFF_COMMAND = '/\\ttsoff'; // The backslash ("\") character is a special escape character. To use backslash character itself, two backslashes are needed.

export const MOD_SEPARATOR = '__';

export const LANGUAGES = {
  ENGLISH: 'english',
  SPANISH: 'spanish',
} as const;
export type Languages = (typeof LANGUAGES)[keyof typeof LANGUAGES];

export const BILINGUAL_RESTAURANT_GROUP = 'bilingual_group';

export const POS_CART_ITEM_PRICE_INTENT = '#pos_cart_item_price';
export const POS_CART_SUBTOTAL_PRICE_INTENT = '#pos_cart_subtotal_price';
export const POS_CART_TOTAL_PRICE_INTENT = '#pos_cart_total_price';

export const SLASH_COMMAND_REMINDERS = {
  DONATION: '/upsell_donation',
  CUSTOMER_INFO: '/customer_info',
  UPSELL_END_OF_ORDER_PREFIX: '/upsell_end_order',
};
